<template>
  <b-container>
    <div v-if="!hideFindReservation">
      <p v-if="!foundReservation">
        <b-tabs content-class="mt-3" justified>
          <b-tab>
            <template #title>
              <strong>{{ $t('quoteOfferForm.findForRoomTitle') }}</strong>
            </template>
            <b-card>
              <b-card-text>
                <reservation-info-from-room
                  v-if="model.startDate"
                  :value="model.startDate"
                  :propertyCODE="model.propertyCODE"
                  @reservationFound="onReservationFound"
                  @findReservationSkipped="onFindReservationSkiped"
                />
              </b-card-text>
            </b-card>
          </b-tab>
          <b-tab>
            <template #title>
              <strong>{{
                $t('quoteOfferForm.findForReservationTitle')
              }}</strong>
            </template>
            <b-card>
              <b-card-text>
                <reservation-info-from-progress
                  v-if="model.startDate"
                  :value="model.startDate"
                  :propertyCODE="model.propertyCODE"
                  @reservationFound="onReservationFound"
                  @findReservationSkipped="onFindReservationSkiped"
                />
              </b-card-text>
            </b-card>
          </b-tab>
        </b-tabs>
        <b-row class="mt-2">
          <b-col>
            <b-alert show variant="warning"
              >{{ $t('quoteOfferForm.proceedWithoutReservation') }}
              <a href="#" v-on:click.prevent="findReservationSkip($event)"
                ><b>{{ $t('click here') }}</b></a
              >
            </b-alert>
          </b-col>
        </b-row>
      </p>
      <div v-else>
        <p v-if="reservationSelected">
          <b-alert show variant="warning">
            <span
              v-html="
                $t('quoteOfferForm.reservationRelated', {
                  progress: model.progress,
                  start: start,
                  end: end,
                })
              "
            />
            &nbsp;
            <a href="#" v-on:click.prevent="removeReservation($event)">{{
              $t('disconnect')
            }}</a>
          </b-alert>
        </p>
      </div>
    </div>
    <div v-else>
      <b-alert show
        >{{ $t('rememberReservation') }}
        <a href="#" v-on:click.prevent="resetReservationFilter($event)">{{
          $t('find')
        }}</a>
      </b-alert>
    </div>

    <form-wrapper :validator="$v.model" v-if="dataStepTwo">
      <b-row class="my-3">
        <b-col sm="2" offset-sm="1">
          <label>{{ $t('form.firstName') }} <sup>*</sup></label>
        </b-col>
        <b-col sm="7">
          <form-group name="firstName" attribute="form.firstName">
            <b-form-input
              slot-scope="{ attrs, listeners }"
              v-bind="attrs"
              v-on="listeners"
              id="input-live-firstname"
              v-model="model.firstName"
              type="text"
              :readonly="firstNameReadOnly"
              :state="$v.model.firstName.$error ? false : null"
              @change="$v.model.firstName.$touch()"
              maxlength="50"
            ></b-form-input>
          </form-group>
        </b-col>
      </b-row>
      <b-row class="my-3">
        <b-col sm="2" offset-sm="1">
          <label>{{ $t('form.lastName') }} <sup>*</sup></label>
        </b-col>
        <b-col sm="7">
          <form-group name="surname" attribute="form.lastname">
            <b-form-input
              slot-scope="{ attrs, listeners }"
              v-bind="attrs"
              v-on="listeners"
              v-model="model.surname"
              :readonly="lastNameReadOnly"
              type="text"
              :state="$v.model.surname.$error ? false : null"
              @change="$v.model.surname.$touch()"
              maxlength="50"
            ></b-form-input>
          </form-group>
        </b-col>
      </b-row>
      <b-row class="my-3">
        <b-col sm="2" offset-sm="1">
          <label>{{ $t('form.email') }} <sup>*</sup></label>
        </b-col>
        <b-col sm="7">
          <form-group name="email" attribute="form.email">
            <b-form-input
              id="input-live-email"
              v-model="model.email"
              :readonly="emailReadOnly"
              type="email"
              :state="$v.model.email.$error ? false : null"
              @change="$v.model.email.$touch()"
              maxlength="200"
            ></b-form-input>
          </form-group>
        </b-col>
      </b-row>
      <b-row class="my-3">
        <b-col sm="2" offset-sm="1">
          <label>{{ $t('form.phoneNumber') }} <sup>*</sup></label>
        </b-col>
        <b-col sm="7">
          <form-group name="phoneNumber" attribute="form.phoneNumber">
            <b-form-input
              v-model="model.phoneNumber"
              slot-scope="{ attrs, listeners }"
              v-bind="attrs"
              v-on="listeners"
              @change="$v.model.phoneNumber.$touch()"
              :state="$v.model.phoneNumber.$error ? false : null"
              maxlength="50"
            ></b-form-input>
          </form-group>
        </b-col>
      </b-row>
      <!-- <b-row class="my-3" v-show="isActive">
        <b-col sm="2" offset-sm="1">
          <label>{{ $t('form.code') }} <sup v-show="isRequired">*</sup></label>
        </b-col>
        <b-col sm="7">
          <form-group name="code" attribute="form.code">
            <b-form-input
              slot-scope="{ attrs, listeners }"
              v-bind="attrs"
              v-on="listeners"
              v-model="model.code"
              :state="$v.model.code.$error ? false : null"
              maxlength="35"
            ></b-form-input>
          </form-group>
        </b-col>
      </b-row> -->
      <b-row class="my-3">
        <b-col sm="2" offset-sm="1">
          <label>{{ $t('form.note') }}:</label>
        </b-col>
        <b-col md="7" offset-sm="1" offset-md="0">
          <b-form-textarea
            id="textarea"
            v-model="model.comment"
            :placeholder="$t('form.note')"
            rows="3"
            max-rows="6"
          ></b-form-textarea>
        </b-col>
      </b-row>
      <b-row class="mt-5">
        <b-col sm="10" offset-sm="1">
          <p class="text-center font-weight-bolder">
            {{ $t('form.privacyTitle') }}
          </p>
        </b-col>
        <b-col sm="10" offset-sm="1">
          <p class="text-center font-weight-normal">
            {{ $t('form.privacyBody') }}
            <a target="_blank" v-bind:href="$t('form.privacyHyperlink')">{{
              $t('form.privacyHyperlink')
            }}</a>
          </p>
        </b-col>
      </b-row>
      <b-row class="my-4">
        <b-col sm="10" offset-sm="1">
          <form-group
            name="privacy"
            attribute="form.privacy"
            class="text-center font-weight-normal"
          >
            <!-- <label id="privacyLabel">{{$t('form.privacyAgree')}}</label> -->
            <b-form-checkbox
              id="privacy"
              :state="$v.model.privacy.$error ? false : null"
              @change="$v.model.privacy.$touch()"
              v-model="model.privacy"
            >
              {{ $t('form.privacyAgree') }} <sup>*</sup>
            </b-form-checkbox>
          </form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col sm="10" offset-sm="1">
          <b-alert show variant="danger">{{ $t('requestWarning') }} </b-alert>
        </b-col>
      </b-row>
      <div style="margin-bottom: 20px">
        <form-summary :attributes="attributes" />
      </div>
    </form-wrapper>
  </b-container>
</template>

<script>
import { validationMixin } from 'vuelidate';
import {
  required,
  minLength,
  maxLength,
  email,
} from 'vuelidate/lib/validators';
import { format } from 'date-fns';

import { FormWizard, TabContent } from 'vue-form-wizard';
import ReservationInfoFromProgress from '@/components/RequestLogin/ReservationInfoFromProgress';
// import ReservationInfoFromName from '@/components/RequestLogin/ReservationInfoFromName';
import ReservationInfoFromRoom from '@/components/RequestLogin/ReservationInfoFromRoom';
export default {
  name: 'RequestQuoteStepTwo',
  // props: ["data"],
  props: {
    formConfiguration: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    model: {
      type: Object,
      required: true,
    },
  },
  mixins: [validationMixin],

  // component code
  components: {
    FormWizard,
    TabContent,
    ReservationInfoFromProgress,
    // ReservationInfoFromName,
    ReservationInfoFromRoom,
  },
  data() {
    return {
      isRequired: false,
      dataStepTwo: false,
      foundReservation: false,
      hideFindReservation: false,
      reservationSelected: false,
      contactSelected: false,
      firstNameReadOnly: false,
      lastNameReadOnly: false,
      emailReadOnly: false,
      attributes: {
        phoneNumber: this.$t('form.phoneNumber'),
        lastname: this.$t('form.lastName'),
        firstName: this.$t('form.firstName'),
        email: this.$t('form.email'),
        privacy: this.$t('form.privacy'),
        code: this.$t('form.code'),
      },
    };
  },
  validations: {
    model: {
      firstName: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(50),
      },
      surname: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(50),
      },
      email: {
        required,
        email,
        minLength: minLength(3),
        maxLength: maxLength(200),
      },
      phoneNumber: {
        required,
        maxLength: maxLength(50),
      },
      privacy: {
        privacyChecked: (value) => value === true,
      },
      // code: {
      //   required: requiredIf(function () {
      //     return this.isRequired;
      //   }),
      //   invalidCode: (code, model) => model.validCode === true,
      // },
    },
  },
  watch: {
    dataStepTwo(val) {
      this.$emit('disableNextButton', !val);
    },
    'model.firstName'() {
      if (this.model.reservationID && parseInt(this.model.reservationID) > 0) {
        this.hideFindReservation = false;
        this.foundReservation = true;
        this.dataStepTwo = true;
      }
    },
  },
  methods: {
    validate() {
      return new Promise((resolve, reject) => {
        this.$v.$touch();
        if (!this.$v.$invalid) {
          resolve(true);
        } else {
          reject({ invalid: true });
        }
      });
    },
    onReservationFound(model) {
      this.foundReservation = false;
      if (model) {
        if (model.reservationID) {
          this.foundReservation = true;
          this.dataStepTwo = true;
          this.model.reservationID = model.reservationID;
          this.model.progress = model.progress;
          this.model.checkIn = model.checkIn;
          this.model.checkOut = model.checkOut;
          this.reservationSelected = true;
        }
        if (model.contactID) {
          this.contactSelected = true;
          this.model.contactID = model.contactID;
        }

        this.model.email = model.email;
        this.model.firstName = model.firstName;
        this.model.surname = model.surname;
        this.model.phoneNumber = model.phoneNumber;
        this.firstNameReadOnly =
          (this.reservationSelected || this.contactSelected) &&
          this.model.firstName !== null &&
          this.model.firstName !== '' &&
          (this.model.firstName || '').trim() !== '';
        this.lastNameReadOnly =
          (this.reservationSelected || this.contactSelected) &&
          this.model.surname !== null &&
          this.model.surname !== '' &&
          (this.model.surname || '').trim() !== '';
        this.emailReadOnly =
          (this.reservationSelected || this.contactSelected) &&
          this.model.email !== null &&
          this.model.email !== '' &&
          (this.model.email || '').trim() !== '';
      }
    },
    onFindReservationSkiped() {
      this.dataStepTwo = true;
      this.hideFindReservation = true;
    },
    resetReservationFilter() {
      this.hideFindReservation = false;
      this.foundReservation = false;
      this.dataStepTwo = false;
      this.model.reservationID = null;
    },
    removeReservation(val) {
      this.model.reservationID = null;
      // this.model.email = null;
      // this.model.firstName = null;
      // this.model.lastName = null;
      this.dataStepTwo = false;
      this.hideFindReservation = false;
      this.foundReservation = false;
      this.reservationSelected = false;
    },
    findReservationSkip(event) {
      this.onFindReservationSkiped();
    },
  },
  computed: {
    isActive() {
      let active = false;
      this.isRequired = false;
      if (this.model.property) {
        const propertyConficuration = this.formConfiguration.properties.find(
          (x) => x.propertyCODE === this.model.property
        );
        if (propertyConficuration) {
          if (propertyConficuration.isActive) {
            active = true;
          }
          if (propertyConficuration.isRequired) {
            this.isRequired = true;
          }
        }
      }
      return active;
    },
    start() {
      return format(this.model.checkIn, 'DD-MM-YYYY');
    },
    end() {
      return format(this.model.checkOut, 'DD-MM-YYYY');
    },
  },
};
</script>
